export default __webpack_public_path__ + "static/media/Screenshot 2022-03-17 145530.4d9d9fb2.png";